import type { StyleLayer } from './utils/types'

export const layers_parkingLars_parkinglines: StyleLayer[] = [
  {
    id: 'street parking lines',
    type: 'line',
    filter: ['has', 'capacity'],
    paint: {
      'line-color': 'hsl(211, 91%, 39%)',
      'line-opacity': ['match', ['get', 'operator_type'], ['private'], 0.33, 1],
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 16],
    },
  },
  {
    id: 'parallel pattern',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'orientation'], ['parallel'], true, false],
      ['has', 'capacity'],
    ],
    paint: {
      'line-color': 'rgb(237, 237, 237)',
      'line-dasharray': [4, 2],
      'line-opacity': 0.67,
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 0.7, 20, 5],
    },
  },
  {
    id: 'diagonal pattern',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'orientation'], ['diagonal'], true, false],
      ['has', 'capacity'],
    ],
    minzoom: 16,
    paint: {
      'line-color': 'rgb(237, 237, 237)',
      'line-opacity': 0.67,
      'line-pattern': 'pattern-parking-diagonal',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 16],
    },
  },
  {
    id: 'perpendicular pattern',
    type: 'line',
    filter: [
      'all',
      ['match', ['get', 'orientation'], ['perpendicular'], true, false],
      ['has', 'capacity'],
    ],
    minzoom: 16,
    paint: {
      'line-color': 'rgb(237, 237, 237)',
      'line-opacity': 0.67,
      'line-pattern': 'pattern-parking-perpendicular',
      'line-width': ['interpolate', ['linear'], ['zoom'], 16, 2, 20, 16],
    },
  },
]
